module.exports = __webpack_public_path__ + "static/media/another-view2.6fdd919e.png";